import React from 'react';
import Imgix from 'react-imgix';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';

const HeaderLogo = ({ link, match, storeLocation, logoPicture, location }) => {
  if (!link || link == '') {
    link = '/';
  }

  const firstPartOfUrl = location.pathname.split('/')[1] || '';
  const pageClass = `${firstPartOfUrl}Page`;

  return logoPicture ? (
    <figure
      className={classnames({
        headerLogo: true,
      })}
    >
      <a href={link}>
        <Imgix src={logoPicture.imgixUrl} alt='logo' fit='max' sizes='50vw' />
      </a>
    </figure>
  ) : (
    <h1
      className={classnames({
        headerTitle: true,
        [pageClass]: true,
      })}
    >
      {storeLocation.name}
    </h1>
  );
};

export default withRouter(HeaderLogo);
